import entities from "src/constants/entities";
import { QueryKeyType } from "../paginationQuery/useDataWithPagination";
import ActivityQueryTypes from "src/constants/activityQueryTypes";

export enum SortEnum {
  ASC = "ASC",
  DESC = "DESC",
}
export interface ActivitySortOptions {
  sortBy: string;
  sortType: SortEnum;
}

export type ActivitiesOptions = {
  companyId: string | null;
  type: string;
  sort?: ActivitySortOptions;
  filters: {
    query: string;
    startDate: number | null; //  timestamp
    endDate: number | null; // timestamp
    type: ActivityQueryTypes | null;
    readStatus: boolean | null;
    isTransferred: boolean | null;
    transfer: string | null;
    isArchived?: boolean;
    hasSummary?: boolean;
    answeredBy?: string | null;
    callsInProgress?: boolean;
  };
};

export interface ActivitiesBadgeOption {
  companyId: string | null;
}

type ActivityKeysType = {
  activitiesList: (
    options: ActivitiesOptions
  ) => QueryKeyType<ActivitiesOptions>;
  activitiesBadge: (
    options: ActivitiesBadgeOption
  ) => QueryKeyType<ActivitiesBadgeOption>;
  exportActivity: (
    options: ActivitiesBadgeOption
  ) => QueryKeyType<ActivitiesBadgeOption>;
};

export const activitiesKeys: ActivityKeysType = {
  activitiesList: (options: ActivitiesOptions) => [
    entities.ACTIVITIES,
    {
      companyId: options.companyId,
      type: options.type,
      sort: options.sort,
      filters: {
        query: options.filters.query,
        startDate: options.filters.startDate,
        endDate: options.filters.endDate,
        type: options.filters.type,
        readStatus: options.filters.readStatus,
        isTransferred: options.filters.isTransferred,
        transfer: options.filters.transfer,
        isArchived: options.filters?.isArchived,
        hasSummary: options?.filters?.hasSummary,
        answeredBy: options?.filters?.answeredBy,
        callsInProgress: options.filters?.callsInProgress,
      },
    },
  ],
  activitiesBadge: (options: ActivitiesBadgeOption) => [
    entities.ACTIVITY_BADGE,
    {
      companyId: options.companyId,
    },
  ],
  exportActivity: (options: ActivitiesBadgeOption) => [
    entities.ACTIVITY_BADGE,
    {
      companyId: options.companyId,
    },
  ],
};

// (string | { companyId: string | null; type: string; })[]
